import React from "react";
import { Link } from "react-router-dom";
import tutifyLogo from "../../assets/images/tutify-white-logo.png";

const FooterLogo = () => {
  return (
    <Link className="navbar-brand" to="/">
      <img style={{height:"80px",}} src={tutifyLogo} alt="Tutify Logo" />
    </Link>
  );
};

export default FooterLogo;
